import { call, put, select as sagaSelect } from 'redux-saga/effects';

import * as actions from './sessions.actions';

import * as sessionResourceService from '../../../resource/session/session.saga-service';

import {
  IDeleteSessionSocketPayload,
  ISession,
  ISessionCreate,
  ISessionSave,
  ISessionSearchParams,
  ISessionUpdate,
} from '../../../resource/session/session.types';
import { select, selectWithParams } from '../../../../utils/selector.utils';
import { sessionSelectors } from '../../../resource/session/session.selectors';
import { authSelectors } from '../../../auth/auth.selectors';
import { IUser } from '../../../resource/user/user.types';
import { storeSessionIds as sessionPageStoreSessionIds } from './sessions.actions';
import { storeSessionIds as kpiPageStoreSessionIds } from '../kpi/kpi.actions';
import { kpiPageSelectors } from '../kpi/kpi.selectors';
import * as api from '../../../api/request-config/session.api';
import { apiRequest } from '../../../api/api.saga-services';
import * as sessionActions from '../sessions/sessions.actions';
import * as meetingActions from '../meetings-simple/meetings-simple.actions';
import { IMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.types';
import { meetingSimpleSelectors } from '../../../resource/meeting-simple/meeting-simple.selectors';
import { storeMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.actions';
import { findNextMeeting } from '../../../../utils/meeting.utils';

export function* setupSessions(searchParams: ISessionSearchParams) {
  // let sessionIds = null;
  // let nextSessionId = null;
  // if (searchParams.userId) {
  //   const user = (yield call(userService.populateSessions, searchParams.userId)) as IUser;
  //   sessionIds = user.sessionIds;
  // } else if (searchParams.id) {
  //   // const meeting = (yield call(meetingService.populateSessions, searchParams.id)) as IMeeting;
  //   const meeting = (yield selectWithParams(meetingSelectors.selectResourceById, searchParams.id)) as IMeetingSimple;
  //   sessionIds = meeting.sessionIds;
  //   nextSessionId = meeting.nextSessionIds[0];
  // }
  // yield sessionIds ? put(actions.storeSessionIds(sessionIds)) : put(actions.clearSessionIds());
  // if (sessionIds) {
  //   nextSessionId = yield call(findNextSession, sessionIds);
  // }
  // yield nextSessionId ? put(actions.storeNextSession(nextSessionId)) : put(actions.clearNextSession());
}

export function* findNextSession(sessionIds: ISession['id'][]) {
  // const sessions = yield selectWithParams(sessionSelectors.selectResourcesById, sessionIds);
  // // sort by date, and take first greater then current date;
  // return sessions[0] ? sessions[0].id : null;
}

export function* updateSessions(sessionId: ISession['id'], sessionInfo: ISessionUpdate) {
  yield call(sessionResourceService.updateSessions, sessionId, sessionInfo);
}

export function* storeNextSession(sessionId: ISession['id']) {
  yield put(actions.storeNextSession(sessionId));
}
export function* deleteSession(sessionId: ISession['id']) {
  const res = (yield call(apiRequest, api.deleteSessionApi(sessionId))) as unknown;
  if (res) {
    yield call(deleteSessionAndUpdateNextSession, sessionId);
  }
}

export function* deleteSessionAndUpdateNextSession(sessionId: ISession['id']) {
  const session = (yield sagaSelect(sessionSelectors.selectResourceById, sessionId)) as ISession;
  const meetingId = session.meetingId;

  yield call(deleteSessionFromStore, sessionId);

  if (meetingId) {
    const { lastSessionId, nextSession, nextSessionId } = (yield call(
      apiRequest,
      api.getLastAndNextSessionsApi(meetingId),
    )) as {
      lastSession: ISession['sessionDate'];
      lastSessionId: ISession['id'];
      nextSession: ISession['sessionDate'];
      nextSessionId: ISession['id'];
    };
    yield put(sessionActions.storeNextSession(nextSessionId));
    yield put(sessionActions.storeLastSession(lastSessionId));

    const meeting = (yield selectWithParams(meetingSimpleSelectors.selectResourceById, meetingId)) as IMeetingSimple;
    yield put(storeMeetingSimple({ ...meeting, nextSession, nextSessionId }));

    const meetings = (yield select(meetingSimpleSelectors.selectResourceList)) as IMeetingSimple[];
    const nextMeeting = findNextMeeting(meetings);

    if (nextMeeting) {
      yield put(meetingActions.storeNextMeeting(nextMeeting.id));
    }
  }
}

export function* deleteSessionFromStore(sessionId: ISession['id']) {
  const sessionIds = (yield sagaSelect(kpiPageSelectors.selectSessionIds)) as ISession['id'][];
  const newSessionIds = sessionIds.filter((id) => id !== sessionId);
  yield call(storeSessionIdsForPage, newSessionIds);
  yield call(sessionResourceService.deleteSession, sessionId);
}

export function* saveEmail(sessionId: ISession['id'], email: string) {
  yield call(sessionResourceService.saveEmail, sessionId, email);
}

export function* handleSaveSessionFromSocket(id: ISession['id'], payload: ISessionSave) {
  const loggedUserId = (yield select(authSelectors.selectLoggedUser)) as IUser['id'] | null;
  const actionUserId = payload.actionUserId;
  if (loggedUserId === String(actionUserId)) {
    return;
  }

  const session = (yield selectWithParams(sessionSelectors.selectResourceById, id)) as ISession | null;
  if (session) {
    yield call(sessionResourceService.storeSession, { ...session, note: payload.note });
  }
}

export function* handleEmailFromNotification(sessionResponse: ISession) {
  const sessionExists = (yield selectWithParams(
    sessionSelectors.selectResourceById,
    sessionResponse.id,
  )) as ISession | null;

  if (sessionExists) {
    yield call(sessionResourceService.storeSession, { ...sessionResponse });
  }
}

export function* handleDeleteSessionFromSocket(payload: IDeleteSessionSocketPayload) {
  const loggedUserId = (yield select(authSelectors.selectLoggedUser)) as IUser['id'] | null;
  const actionUserId = payload.actionUserId;

  if (loggedUserId === String(actionUserId)) {
    return;
  }

  yield call(deleteSessionAndUpdateNextSession, payload.id);
}

export function* storeSessionIdsForPage(sessionIds: ISession['id'][]) {
  yield put(sessionPageStoreSessionIds(sessionIds));
  yield put(kpiPageStoreSessionIds(sessionIds));
}

export function* clearSessionsPageStorage() {
  yield put(actions.clearSessionIds());
  yield put(actions.clearNextSession());
}
